import { BodyM, HeadingS } from 'components/Typography/Typography';
import { translate } from 'components/Translation';
import React from 'react';
import { makeStyles } from '@material-ui/styles';
import styles from 'assets/jss/material-dashboard-pro-react/views/payments/topupStyle';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';

// @ts-ignore
const useStyles = makeStyles(styles);

interface IHeaderProps {
	isError: boolean;
	topUpValue: string | number;
	donationValue: number;
}

const Header = ({ isError, topUpValue, donationValue }: IHeaderProps) => {
	const classes = useStyles();

	const value: number = Number(topUpValue) + donationValue;

	return (
		<ConditionalRender
			show={isError}
			onTrue={() => (
				<>
					<BodyM disableMargin>{translate('something.went.wrong')}</BodyM>
					<BodyM disableMargin>{translate('payments.topup.pleaseContact')}</BodyM>
					<div className={classes.paymentRejected}>
						<HeadingS color="danger" disableMargin>
							{translate('payments.topup.paymentRejected')}
						</HeadingS>
					</div>
				</>
			)}
			onFalse={() => (
				<>
					<BodyM>{translate('payments.topup.toppedUpSuccessfully')}</BodyM>
					<div className={classes.topUpDialogValue}>
						<p>{translate('price', value)}</p>
					</div>
					<HeadingS color="success" disableMargin>
						{translate('payments.topup.paymentConfirmed')}
					</HeadingS>
				</>
			)}
		/>
	);
};

export default Header;
